import { FlexResponsive, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { StyledDivider } from 'baseui/divider';
import { useBreakpoints } from '../../../hooks/useBreakpoints';
import { useStyles } from '../../../hooks/useStyles';
import { Device } from '../../../types/device';
import LabeledDataCard from '../labeledDataCard/LabeledDataCard';

type Props = Readonly<{
  device?: Device;
}>;

function CurrentStateAnonymousLocation({ device }: Props) {
  const { formatDateFromTs } = useMoment();
  const { isXSmall } = useBreakpoints();
  const { theme, overrides } = useStyles();

  if (!device?.hsWithoutAsset) {
    return null;
  }
  const { hsWithoutAsset } = device;

  if (!hsWithoutAsset.geoReference && (!hsWithoutAsset.position_latitude || !hsWithoutAsset.position_longitude)) {
    return null;
  }

  return (
    <LabeledDataCard
      label="Posición sin asset"
      rootStyleOverrides={{
        flexGrow: 2,
        flexShrink: 1,
        flexBasis: 0,
      }}
    >
      <FlexResponsive
        gap={isXSmall ? 0 : theme.sizing.scale800}
        breakAt="medium"
      >
        <Block>
          <LabeledData
            label="Latitud:"
            content={hsWithoutAsset?.position_latitude ? hsWithoutAsset?.position_latitude.toString() : '-'}
            labelWidth="50px"
            inline={false}
            maxLines={3}
          />
        </Block>
        {isXSmall && <StyledDivider style={overrides.dividerStyleOverrides} />}
        <Block>
          <LabeledData
            label="Longitud:"
            content={hsWithoutAsset?.position_longitude ? hsWithoutAsset?.position_longitude.toString() : '-'}
            labelWidth="50px"
            inline={false}
            maxLines={3}
          />
        </Block>
      </FlexResponsive>
      <StyledDivider style={overrides.dividerStyleOverrides} />
      <LabeledData
        label="Georeferencia:"
        labelWidth="105px"
        content={hsWithoutAsset?.geoReference || '-'}
        inline={false}
        maxLines={5}
      />
      <StyledDivider style={overrides.dividerStyleOverrides} />
      <LabeledData
        label="Ultima posición:"
        content={hsWithoutAsset?.timestamp ? formatDateFromTs(hsWithoutAsset.timestamp) : '-'}
        labelWidth="105px"
        inline={false}
        maxLines={5}
      />
    </LabeledDataCard>
  );
}

export default CurrentStateAnonymousLocation;
